// 引入store
import store from '@/store'
// 按钮权限设置
// 按钮权限设置
export function hasBtnPermission(btnPermission) {
    // buttons就是权限数组
    const myBtns = store.getters.roles
    return myBtns.indexOf(btnPermission) > -1
}